import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorderStatics} from "../TheBorderStatics";

/**
 * Created by Jerker Nord on 2022-05-12.
 */

export class TheBorderSymbolOnTopView extends PIXI.Container implements StageLayer{

    constructor() {
       super();
       this.name = "TheBorderSymbolOnTopView";
       this.position = TheBorderStatics.MAIN_REELS_VIEW_POSITION;
    }
}